import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Breadcrumb, Typography, Spin, Select } from 'antd';
import { capitalize } from '../../redux/actions/customFunction';
import { backButton, formItemLayout, handleBackendFormErrors, tailFormItemLayout } from '../../common_functions';

const Support = props => {
  const { section, section_2, id } = useParams();
  const [confidence, setconfidence] = useState({});
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('');
  const [fields, setFields] = useState([]);
  const formRef = useRef('');
  const supType = capitalize(section_2.replaceAll('-', ' '));
  useEffect(() => {
    async function fetchData() {
      let tab = section_2.replaceAll('-', ' ');
      let newId = id !== 'new' && id;
      let new_choices = [];
      setActiveTab(tab);
      formRef.current.setFieldsValue({ type: tab });
      try {
        setLoading(true);
        let { data: { meta: { options: { choices = [] } = {} } = {} } = {} } = await props.fetchFieldValues('support_table', {
          fields: ['fields'],
        });
        choices.map(function (item) {
          if (tab === 'subject general' && item.value === 'subject_general') {
            return new_choices.push(item);
          }
          tab !== 'subject general' &&
            ((item.text.toLowerCase().includes(tab) && new_choices.push(item)) ||
              (item.text.toLowerCase().includes(tab.split(' ')[0]) && new_choices.push(item)));
        });
        setFields(new_choices);
        if (section && newId) {
          let respData = await props.getItem('support_table', newId);
          setconfidence(respData.data);
          formRef.current.setFieldsValue(respData.data);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [section, id]);

  let onFinish = async values => {
    values.code = values?.code != '' ? values.code : null;
    let newState = { ...confidence, ...values };
    try {
      setLoading(true);
      const response = await props.saveItem('support_table', newState);
      if (response) {
        notification['success']({
          message: supType + ' saved successfully!',
          duration: 2,
        });
        customBackButton();
      }
    } catch (errorResponse) {
      console.log(errorResponse);
      handleBackendFormErrors(formRef, errorResponse);
    } finally {
      setLoading(false);
    }
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };
  let customBackButton = () => {
    localStorage.setItem('activeTab', supType);
    backButton(props, `/settings/support-table`);
  };
  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/support-table" }, { title: "Support Table", href: "/settings/support-table" }, { title: id !== 'new' ? `Edit ${capitalize(activeTab)}` : `Create ${capitalize(activeTab)}` }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {id !== 'new' ? `Edit ${capitalize(activeTab)}: ${id}` : `Add ${capitalize(activeTab)}`}
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="artist">
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              {id !== 'new' ? (
                <Row gutter={24}>
                  {' '}
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item name="id" label="ID(System Generated)">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="fields"
                      label="Field Name"
                      rules={[
                        {
                          whitespace: true,
                          required: true,
                          message: 'Field Name is required!',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select field name"
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                      >
                        {fields.map(el => (
                          <Select.Option key={el.value} value={el.value}>
                            {el.text}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              ) : (
                <Row gutter={24}>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="type"
                      label="Type"
                      rules={[
                        {
                          required: true,
                          message: 'Type is required!',
                        },
                      ]}
                    >
                      <Input readOnly placeholder={activeTab} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="fields"
                      label="Field Name"
                      rules={[
                        {
                          required: true,
                          message: 'Field Name is required!',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select field name"
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                      >
                        {fields.map(el => (
                          <Select.Option key={el.value} value={el.value}>
                            {el.text}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="name"
                    label="Name"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Name is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter the name" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="code"
                    label="Code"
                    rules={[
                      {
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input placeholder="Enter the code" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="source" label="Source">
                    <Input placeholder="Enter the source" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item name="description" label="Description">
                    <Input.TextArea placeholder="Enter the description" autosize={{ minRows: 3 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={customBackButton}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton(props.roleType, props.tabs_permissions.settings_support_table, !!confidence ? confidence.id : '')}
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default Support;
